// @ts-nocheck
const URL = process.env.PUBLIC_URL + '/assets/scenes/surroundings.gltf'
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useEffect, useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'

type GLTFResult = GLTF & {
  nodes: {
    Cylinder015: THREE.Mesh
    Cylinder015_1: THREE.Mesh
    Cylinder016: THREE.Mesh
    Cylinder016_1: THREE.Mesh
    Cylinder013: THREE.Mesh
    Cylinder013_1: THREE.Mesh
    Cylinder014: THREE.Mesh
    Cylinder014_1: THREE.Mesh
    treeD_graveyard001: THREE.Mesh
    treeC_graveyard001: THREE.Mesh
    treeB_graveyard001: THREE.Mesh
    treeA_graveyard001: THREE.Mesh
    Cube251: THREE.Mesh
    Cube251_1: THREE.Mesh
    Cube252: THREE.Mesh
    Cube252_1: THREE.Mesh
    Cube253: THREE.Mesh
    Cube253_1: THREE.Mesh
    Cube254: THREE.Mesh
    Cube254_1: THREE.Mesh
    Cube255: THREE.Mesh
    Cube255_1: THREE.Mesh
    Cube256: THREE.Mesh
    Cube256_1: THREE.Mesh
    Cube257: THREE.Mesh
    Cube257_1: THREE.Mesh
    Cube258: THREE.Mesh
    Cube258_1: THREE.Mesh
    Cube259: THREE.Mesh
    Cube259_1: THREE.Mesh
    Cube260: THREE.Mesh
    Cube260_1: THREE.Mesh
    Cube261: THREE.Mesh
    Cube261_1: THREE.Mesh
    Cube262: THREE.Mesh
    Cube262_1: THREE.Mesh
    Cube263: THREE.Mesh
    Cube263_1: THREE.Mesh
    Cube264: THREE.Mesh
    Cube264_1: THREE.Mesh
    Cube265: THREE.Mesh
    Cube265_1: THREE.Mesh
    Cube267: THREE.Mesh
    Cube267_1: THREE.Mesh
    Cube268: THREE.Mesh
    Cube268_1: THREE.Mesh
    Cube269: THREE.Mesh
    Cube269_1: THREE.Mesh
    Cube270: THREE.Mesh
    Cube270_1: THREE.Mesh
    bricks001: THREE.Mesh
    bricks002: THREE.Mesh
    Cube279: THREE.Mesh
    Cube279_1: THREE.Mesh
    Cube280: THREE.Mesh
    Cube280_1: THREE.Mesh
    Cube281: THREE.Mesh
    Cube281_1: THREE.Mesh
    Cube282: THREE.Mesh
    Cube282_1: THREE.Mesh
    Cube283: THREE.Mesh
    Cube283_1: THREE.Mesh
    Cube284: THREE.Mesh
    Cube284_1: THREE.Mesh
    Cube285: THREE.Mesh
    Cube285_1: THREE.Mesh
    Cube286: THREE.Mesh
    Cube286_1: THREE.Mesh
    Cube287: THREE.Mesh
    Cube287_1: THREE.Mesh
    Cube288: THREE.Mesh
    Cube288_1: THREE.Mesh
    Cube289: THREE.Mesh
    Cube289_1: THREE.Mesh
    Cube290: THREE.Mesh
    Cube290_1: THREE.Mesh
    Cube291: THREE.Mesh
    Cube291_1: THREE.Mesh
    Cube292: THREE.Mesh
    Cube292_1: THREE.Mesh
    Cube293: THREE.Mesh
    Cube293_1: THREE.Mesh
    Cube294: THREE.Mesh
    Cube294_1: THREE.Mesh
    Cube295: THREE.Mesh
    Cube295_1: THREE.Mesh
    Cube296: THREE.Mesh
    Cube296_1: THREE.Mesh
    treeB_graveyard003: THREE.Mesh
    treeA_graveyard003: THREE.Mesh
    treeD_graveyard003: THREE.Mesh
    treeC_graveyard003: THREE.Mesh
    treeD_graveyard004: THREE.Mesh
    treeC_graveyard004: THREE.Mesh
    treeB_graveyard004: THREE.Mesh
    treeA_graveyard004: THREE.Mesh
    Cube297: THREE.Mesh
    Cube297_1: THREE.Mesh
    Cube298: THREE.Mesh
    Cube298_1: THREE.Mesh
    Sphere004: THREE.Mesh
    Sphere004_1: THREE.Mesh
    Sphere005: THREE.Mesh
    Sphere005_1: THREE.Mesh
    treeD_graveyard005: THREE.Mesh
    treeC_graveyard005: THREE.Mesh
    treeB_graveyard005: THREE.Mesh
    treeA_graveyard005: THREE.Mesh
    Sphere006: THREE.Mesh
    Sphere006_1: THREE.Mesh
    Sphere007: THREE.Mesh
    Sphere007_1: THREE.Mesh
    Cube300: THREE.Mesh
    Cube300_1: THREE.Mesh
    Cube300_2: THREE.Mesh
    gravestone001: THREE.Mesh
    gravestone002: THREE.Mesh
    gravestone003: THREE.Mesh
    gravestone004: THREE.Mesh
    gravestone005: THREE.Mesh
    gravestone006: THREE.Mesh
    shrine001: THREE.Mesh
    shrine002: THREE.Mesh
    Cube272: THREE.Mesh
    Cube272_1: THREE.Mesh
    Cube273: THREE.Mesh
    Cube273_1: THREE.Mesh
    Cube275: THREE.Mesh
    Cube275_1: THREE.Mesh
    Cube276: THREE.Mesh
    Cube276_1: THREE.Mesh
    treeA_graveyard002: THREE.Mesh
    treeB_graveyard002: THREE.Mesh
    treeC_graveyard002: THREE.Mesh
    treeD_graveyard002: THREE.Mesh
    fence003: THREE.Mesh
    fence004: THREE.Mesh
    Cylinder106: THREE.Mesh
    Cylinder106_1: THREE.Mesh
    Cylinder106_2: THREE.Mesh
  }
  materials: {
    ['Black.023']: THREE.MeshStandardMaterial
    ['Stone.014']: THREE.MeshStandardMaterial
    ['Black.024']: THREE.MeshStandardMaterial
    ['Stone.015']: THREE.MeshStandardMaterial
    ['Black.021']: THREE.MeshStandardMaterial
    ['Yellow.011']: THREE.MeshStandardMaterial
    ['Black.022']: THREE.MeshStandardMaterial
    ['Yellow.012']: THREE.MeshStandardMaterial
    ['DarkWood.019']: THREE.MeshStandardMaterial
    ['DarkWood.020']: THREE.MeshStandardMaterial
    ['DarkWood.021']: THREE.MeshStandardMaterial
    ['DarkWood.022']: THREE.MeshStandardMaterial
    ['Mud.018']: THREE.MeshStandardMaterial
    ['DarkWood.039']: THREE.MeshStandardMaterial
    ['Mud.019']: THREE.MeshStandardMaterial
    ['DarkWood.040']: THREE.MeshStandardMaterial
    ['Mud.020']: THREE.MeshStandardMaterial
    ['DarkWood.041']: THREE.MeshStandardMaterial
    ['Mud.021']: THREE.MeshStandardMaterial
    ['DarkWood.042']: THREE.MeshStandardMaterial
    ['Mud.022']: THREE.MeshStandardMaterial
    ['DarkWood.043']: THREE.MeshStandardMaterial
    ['Mud.023']: THREE.MeshStandardMaterial
    ['DarkWood.044']: THREE.MeshStandardMaterial
    ['Mud.024']: THREE.MeshStandardMaterial
    ['DarkWood.045']: THREE.MeshStandardMaterial
    ['Mud.025']: THREE.MeshStandardMaterial
    ['DarkWood.046']: THREE.MeshStandardMaterial
    ['Mud.026']: THREE.MeshStandardMaterial
    ['DarkWood.047']: THREE.MeshStandardMaterial
    ['Mud.027']: THREE.MeshStandardMaterial
    ['DarkWood.048']: THREE.MeshStandardMaterial
    ['Mud.028']: THREE.MeshStandardMaterial
    ['DarkWood.049']: THREE.MeshStandardMaterial
    ['Mud.029']: THREE.MeshStandardMaterial
    ['DarkWood.050']: THREE.MeshStandardMaterial
    ['Mud.030']: THREE.MeshStandardMaterial
    ['DarkWood.051']: THREE.MeshStandardMaterial
    ['Mud.031']: THREE.MeshStandardMaterial
    ['DarkWood.052']: THREE.MeshStandardMaterial
    ['Mud.032']: THREE.MeshStandardMaterial
    ['DarkWood.053']: THREE.MeshStandardMaterial
    ['Mud.034']: THREE.MeshStandardMaterial
    ['DarkWood.055']: THREE.MeshStandardMaterial
    ['Mud.035']: THREE.MeshStandardMaterial
    ['DarkWood.056']: THREE.MeshStandardMaterial
    ['Mud.036']: THREE.MeshStandardMaterial
    ['DarkWood.057']: THREE.MeshStandardMaterial
    ['Mud.037']: THREE.MeshStandardMaterial
    ['DarkWood.058']: THREE.MeshStandardMaterial
    ['Stone.067']: THREE.MeshStandardMaterial
    ['Stone.068']: THREE.MeshStandardMaterial
    ['Mud.042']: THREE.MeshStandardMaterial
    ['DarkWood.067']: THREE.MeshStandardMaterial
    ['Mud.043']: THREE.MeshStandardMaterial
    ['DarkWood.068']: THREE.MeshStandardMaterial
    ['Mud.044']: THREE.MeshStandardMaterial
    ['DarkWood.069']: THREE.MeshStandardMaterial
    ['Mud.045']: THREE.MeshStandardMaterial
    ['DarkWood.070']: THREE.MeshStandardMaterial
    ['Mud.046']: THREE.MeshStandardMaterial
    ['DarkWood.071']: THREE.MeshStandardMaterial
    ['Mud.047']: THREE.MeshStandardMaterial
    ['DarkWood.072']: THREE.MeshStandardMaterial
    ['Mud.048']: THREE.MeshStandardMaterial
    ['DarkWood.073']: THREE.MeshStandardMaterial
    ['Mud.049']: THREE.MeshStandardMaterial
    ['DarkWood.074']: THREE.MeshStandardMaterial
    ['Mud.050']: THREE.MeshStandardMaterial
    ['DarkWood.075']: THREE.MeshStandardMaterial
    ['Mud.051']: THREE.MeshStandardMaterial
    ['DarkWood.076']: THREE.MeshStandardMaterial
    ['Mud.052']: THREE.MeshStandardMaterial
    ['DarkWood.077']: THREE.MeshStandardMaterial
    ['Mud.053']: THREE.MeshStandardMaterial
    ['DarkWood.078']: THREE.MeshStandardMaterial
    ['Mud.054']: THREE.MeshStandardMaterial
    ['DarkWood.079']: THREE.MeshStandardMaterial
    ['Mud.055']: THREE.MeshStandardMaterial
    ['DarkWood.080']: THREE.MeshStandardMaterial
    ['Mud.056']: THREE.MeshStandardMaterial
    ['DarkWood.081']: THREE.MeshStandardMaterial
    ['Mud.057']: THREE.MeshStandardMaterial
    ['DarkWood.082']: THREE.MeshStandardMaterial
    ['Mud.058']: THREE.MeshStandardMaterial
    ['DarkWood.083']: THREE.MeshStandardMaterial
    ['Mud.059']: THREE.MeshStandardMaterial
    ['DarkWood.084']: THREE.MeshStandardMaterial
    ['DarkWood.085']: THREE.MeshStandardMaterial
    ['DarkWood.086']: THREE.MeshStandardMaterial
    ['DarkWood.087']: THREE.MeshStandardMaterial
    ['DarkWood.088']: THREE.MeshStandardMaterial
    ['DarkWood.089']: THREE.MeshStandardMaterial
    ['DarkWood.090']: THREE.MeshStandardMaterial
    ['DarkWood.091']: THREE.MeshStandardMaterial
    ['DarkWood.092']: THREE.MeshStandardMaterial
    ['Mud.060']: THREE.MeshStandardMaterial
    ['DarkWood.093']: THREE.MeshStandardMaterial
    ['Mud.061']: THREE.MeshStandardMaterial
    ['DarkWood.094']: THREE.MeshStandardMaterial
    ['Orange.014']: THREE.MeshStandardMaterial
    ['GreenDark.002']: THREE.MeshStandardMaterial
    ['Orange.015']: THREE.MeshStandardMaterial
    ['GreenDark.003']: THREE.MeshStandardMaterial
    ['DarkWood.095']: THREE.MeshStandardMaterial
    ['DarkWood.096']: THREE.MeshStandardMaterial
    ['DarkWood.097']: THREE.MeshStandardMaterial
    ['DarkWood.098']: THREE.MeshStandardMaterial
    ['Orange.016']: THREE.MeshStandardMaterial
    ['GreenDark.004']: THREE.MeshStandardMaterial
    ['Orange.017']: THREE.MeshStandardMaterial
    ['GreenDark.005']: THREE.MeshStandardMaterial
    ['Black.053']: THREE.MeshStandardMaterial
    ['Metal.004']: THREE.MeshStandardMaterial
    ['Red.002']: THREE.MeshStandardMaterial
    ['Stone.069']: THREE.MeshStandardMaterial
    ['Stone.070']: THREE.MeshStandardMaterial
    ['Stone.071']: THREE.MeshStandardMaterial
    ['Stone.072']: THREE.MeshStandardMaterial
    ['Stone.073']: THREE.MeshStandardMaterial
    ['Stone.074']: THREE.MeshStandardMaterial
    ['Stone.065']: THREE.MeshStandardMaterial
    ['Stone.066']: THREE.MeshStandardMaterial
    ['Mud.038']: THREE.MeshStandardMaterial
    ['DarkWood.059']: THREE.MeshStandardMaterial
    ['Mud.039']: THREE.MeshStandardMaterial
    ['DarkWood.060']: THREE.MeshStandardMaterial
    ['Mud.040']: THREE.MeshStandardMaterial
    ['DarkWood.061']: THREE.MeshStandardMaterial
    ['Mud.041']: THREE.MeshStandardMaterial
    ['DarkWood.062']: THREE.MeshStandardMaterial
    ['DarkWood.064']: THREE.MeshStandardMaterial
    ['DarkWood.063']: THREE.MeshStandardMaterial
    ['DarkWood.066']: THREE.MeshStandardMaterial
    ['DarkWood.065']: THREE.MeshStandardMaterial
    ['Black.055']: THREE.MeshStandardMaterial
    ['Black.056']: THREE.MeshStandardMaterial
    ['White.008']: THREE.MeshStandardMaterial
    ['Black.065']: THREE.MeshStandardMaterial
    ['Yellow.013']: THREE.MeshStandardMaterial
  }
}

export function Model(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF(URL) as GLTFResult

  return (
    <group {...props} dispose={null}>
      <group name="fenceDouble001" position={[4.58, 0, -7.38]} userData={{ name: 'fenceDouble.001' }}>
        <mesh
          name="Cylinder015"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder015.geometry}
          material={materials['Black.023']}
        />
        <mesh
          name="Cylinder015_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder015_1.geometry}
          material={materials['Stone.014']}
        />
      </group>
      <group name="fenceDouble002" position={[-4.49, 0, 6.43]} userData={{ name: 'fenceDouble.002' }}>
        <mesh
          name="Cylinder016"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder016.geometry}
          material={materials['Black.024']}
        />
        <mesh
          name="Cylinder016_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder016_1.geometry}
          material={materials['Stone.015']}
        />
      </group>
      <group name="lampPost001" position={[1.84, 0, -7.4]} userData={{ name: 'lampPost.001' }}>
        <mesh
          name="Cylinder013"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder013.geometry}
          material={materials['Black.021']}
        />
        <mesh
          name="Cylinder013_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder013_1.geometry}
          material={materials['Yellow.011']}
        />
      </group>
      <group name="lampPost002" position={[-1.79, 0, 6.53]} userData={{ name: 'lampPost.002' }}>
        <mesh
          name="Cylinder014"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder014.geometry}
          material={materials['Black.022']}
        />
        <mesh
          name="Cylinder014_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder014_1.geometry}
          material={materials['Yellow.012']}
        />
      </group>
      <mesh
        name="treeD_graveyard001"
        castShadow
        receiveShadow
        geometry={nodes.treeD_graveyard001.geometry}
        material={materials['DarkWood.019']}
        position={[5.25, 0, 6.76]}
        userData={{ name: 'treeD_graveyard.001' }}
      />
      <mesh
        name="treeC_graveyard001"
        castShadow
        receiveShadow
        geometry={nodes.treeC_graveyard001.geometry}
        material={materials['DarkWood.020']}
        position={[6.76, 0, 6.76]}
        userData={{ name: 'treeC_graveyard.001' }}
      />
      <mesh
        name="treeB_graveyard001"
        castShadow
        receiveShadow
        geometry={nodes.treeB_graveyard001.geometry}
        material={materials['DarkWood.021']}
        position={[-5.66, 0, -7.64]}
        rotation={[0, 0.09, 0]}
        userData={{ name: 'treeB_graveyard.001' }}
      />
      <mesh
        name="treeA_graveyard001"
        castShadow
        receiveShadow
        geometry={nodes.treeA_graveyard001.geometry}
        material={materials['DarkWood.022']}
        position={[-6.81, 0, -7.54]}
        rotation={[0, 0.09, 0]}
        userData={{ name: 'treeA_graveyard.001' }}
      />
      <group
        name="tileLow_graveyard004"
        position={[4.02, -1, -8.07]}
        rotation={[0, 1.57, 0]}
        scale={[1, 1, 2.96]}
        userData={{ name: 'tileLow_graveyard.004' }}
      >
        <mesh
          name="Cube251"
          castShadow
          receiveShadow
          geometry={nodes.Cube251.geometry}
          material={materials['Mud.018']}
        />
        <mesh
          name="Cube251_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube251_1.geometry}
          material={materials['DarkWood.039']}
        />
      </group>
      <group
        name="tileLow_graveyard008"
        position={[-8.98, -1, 1.89]}
        scale={[1, 1, 2.96]}
        userData={{ name: 'tileLow_graveyard.008' }}
      >
        <mesh
          name="Cube252"
          castShadow
          receiveShadow
          geometry={nodes.Cube252.geometry}
          material={materials['Mud.019']}
        />
        <mesh
          name="Cube252_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube252_1.geometry}
          material={materials['DarkWood.040']}
        />
      </group>
      <group
        name="tileLow_graveyard009"
        position={[9.02, -1, -2.9]}
        scale={[1, 1, 2.96]}
        userData={{ name: 'tileLow_graveyard.009' }}
      >
        <mesh
          name="Cube253"
          castShadow
          receiveShadow
          geometry={nodes.Cube253.geometry}
          material={materials['Mud.020']}
        />
        <mesh
          name="Cube253_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube253_1.geometry}
          material={materials['DarkWood.041']}
        />
      </group>
      <group
        name="tileLow_graveyard010"
        position={[-4.83, -1, -8.07]}
        rotation={[0, 1.57, 0]}
        scale={[1, 1, 2.96]}
        userData={{ name: 'tileLow_graveyard.010' }}
      >
        <mesh
          name="Cube254"
          castShadow
          receiveShadow
          geometry={nodes.Cube254.geometry}
          material={materials['Mud.021']}
        />
        <mesh
          name="Cube254_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube254_1.geometry}
          material={materials['DarkWood.042']}
        />
      </group>
      <group
        name="tileLow_graveyard011"
        position={[-4.17, -1, 6.92]}
        rotation={[0, 1.57, 0]}
        scale={[1, 1, 2.96]}
        userData={{ name: 'tileLow_graveyard.011' }}
      >
        <mesh
          name="Cube255"
          castShadow
          receiveShadow
          geometry={nodes.Cube255.geometry}
          material={materials['Mud.022']}
        />
        <mesh
          name="Cube255_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube255_1.geometry}
          material={materials['DarkWood.043']}
        />
      </group>
      <group
        name="tileLow_graveyard012"
        position={[4.68, -1, 6.92]}
        rotation={[0, 1.57, 0]}
        scale={[1, 1, 2.96]}
        userData={{ name: 'tileLow_graveyard.012' }}
      >
        <mesh
          name="Cube256"
          castShadow
          receiveShadow
          geometry={nodes.Cube256.geometry}
          material={materials['Mud.023']}
        />
        <mesh
          name="Cube256_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube256_1.geometry}
          material={materials['DarkWood.044']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard001"
        position={[3.29, -1.05, -10.05]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.001' }}
      >
        <mesh
          name="Cube257"
          castShadow
          receiveShadow
          geometry={nodes.Cube257.geometry}
          material={materials['Mud.024']}
        />
        <mesh
          name="Cube257_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube257_1.geometry}
          material={materials['DarkWood.045']}
        />
      </group>
      <group
        name="tileHigh_graveyard001"
        position={[0.01, -1, -10.04]}
        scale={[2.47, 1, 1]}
        userData={{ name: 'tileHigh_graveyard.001' }}
      >
        <mesh
          name="Cube258"
          castShadow
          receiveShadow
          geometry={nodes.Cube258.geometry}
          material={materials['Mud.025']}
        />
        <mesh
          name="Cube258_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube258_1.geometry}
          material={materials['DarkWood.046']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard002"
        position={[-3.25, -1, -10.05]}
        rotation={[-Math.PI, 0, 0]}
        scale={-1}
        userData={{ name: 'tileSlopeLowHigh_graveyard.002' }}
      >
        <mesh
          name="Cube259"
          castShadow
          receiveShadow
          geometry={nodes.Cube259.geometry}
          material={materials['Mud.026']}
        />
        <mesh
          name="Cube259_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube259_1.geometry}
          material={materials['DarkWood.047']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard003"
        position={[1.12, -1, 9.25]}
        rotation={[-Math.PI, 0, 0]}
        scale={[-0.67, -1, -1]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.003' }}
      >
        <mesh
          name="Cube260"
          castShadow
          receiveShadow
          geometry={nodes.Cube260.geometry}
          material={materials['Mud.027']}
        />
        <mesh
          name="Cube260_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube260_1.geometry}
          material={materials['DarkWood.048']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard004"
        position={[5.51, -1.05, 9.25]}
        scale={[0.67, 1, 1]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.004' }}
      >
        <mesh
          name="Cube261"
          castShadow
          receiveShadow
          geometry={nodes.Cube261.geometry}
          material={materials['Mud.028']}
        />
        <mesh
          name="Cube261_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube261_1.geometry}
          material={materials['DarkWood.049']}
        />
      </group>
      <group
        name="tileHigh_graveyard002"
        position={[3.31, -1, 9.26]}
        scale={[1.66, 1, 1]}
        userData={{ name: 'tileHigh_graveyard.002' }}
      >
        <mesh
          name="Cube262"
          castShadow
          receiveShadow
          geometry={nodes.Cube262.geometry}
          material={materials['Mud.029']}
        />
        <mesh
          name="Cube262_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube262_1.geometry}
          material={materials['DarkWood.050']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard005"
        position={[-1.16, -1.05, 9.25]}
        scale={[0.67, 1, 1]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.005' }}
      >
        <mesh
          name="Cube263"
          castShadow
          receiveShadow
          geometry={nodes.Cube263.geometry}
          material={materials['Mud.030']}
        />
        <mesh
          name="Cube263_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube263_1.geometry}
          material={materials['DarkWood.051']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard006"
        position={[-5.55, -1, 9.25]}
        rotation={[-Math.PI, 0, 0]}
        scale={[-0.67, -1, -1]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.006' }}
      >
        <mesh
          name="Cube264"
          castShadow
          receiveShadow
          geometry={nodes.Cube264.geometry}
          material={materials['Mud.031']}
        />
        <mesh
          name="Cube264_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube264_1.geometry}
          material={materials['DarkWood.052']}
        />
      </group>
      <group
        name="tileHigh_graveyard003"
        position={[-3.36, -1, 9.26]}
        scale={[1.66, 1, 1]}
        userData={{ name: 'tileHigh_graveyard.003' }}
      >
        <mesh
          name="Cube265"
          castShadow
          receiveShadow
          geometry={nodes.Cube265.geometry}
          material={materials['Mud.032']}
        />
        <mesh
          name="Cube265_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube265_1.geometry}
          material={materials['DarkWood.053']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard007"
        position={[9.63, -1, 1.53]}
        rotation={[0, 1.57, 0]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.007' }}
      >
        <mesh
          name="Cube267"
          castShadow
          receiveShadow
          geometry={nodes.Cube267.geometry}
          material={materials['Mud.034']}
        />
        <mesh
          name="Cube267_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube267_1.geometry}
          material={materials['DarkWood.055']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard008"
        position={[9.63, -1, 3.46]}
        rotation={[Math.PI, -1.57, 0]}
        scale={-1}
        userData={{ name: 'tileSlopeLowHigh_graveyard.008' }}
      >
        <mesh
          name="Cube268"
          castShadow
          receiveShadow
          geometry={nodes.Cube268.geometry}
          material={materials['Mud.035']}
        />
        <mesh
          name="Cube268_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube268_1.geometry}
          material={materials['DarkWood.056']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard009"
        position={[-10.19, -1, -4.79]}
        rotation={[0, 1.57, 0]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.009' }}
      >
        <mesh
          name="Cube269"
          castShadow
          receiveShadow
          geometry={nodes.Cube269.geometry}
          material={materials['Mud.036']}
        />
        <mesh
          name="Cube269_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube269_1.geometry}
          material={materials['DarkWood.057']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard010"
        position={[-10.19, -1, -2.79]}
        rotation={[0, 1.57, 0]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.010' }}
      >
        <mesh
          name="Cube270"
          castShadow
          receiveShadow
          geometry={nodes.Cube270.geometry}
          material={materials['Mud.037']}
        />
        <mesh
          name="Cube270_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube270_1.geometry}
          material={materials['DarkWood.058']}
        />
      </group>
      <mesh
        name="bricks001"
        castShadow
        receiveShadow
        geometry={nodes.bricks001.geometry}
        material={materials['Stone.067']}
        position={[-8.96, 0, 0]}
        userData={{ name: 'bricks.001' }}
      />
      <mesh
        name="bricks002"
        castShadow
        receiveShadow
        geometry={nodes.bricks002.geometry}
        material={materials['Stone.068']}
        position={[3.09, 0, 6.88]}
        rotation={[Math.PI, -1.23, Math.PI]}
        userData={{ name: 'bricks.002' }}
      />
      <group
        name="tileSlopeLowHigh_graveyard013"
        position={[10.61, -1, -17.04]}
        rotation={[-Math.PI, 1.57, 0]}
        scale={[-1, -1, -4.42]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.013' }}
      >
        <mesh
          name="Cube279"
          castShadow
          receiveShadow
          geometry={nodes.Cube279.geometry}
          material={materials['Mud.042']}
        />
        <mesh
          name="Cube279_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube279_1.geometry}
          material={materials['DarkWood.067']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard014"
        position={[10.61, -1.05, -10.5]}
        rotation={[0, -1.57, 0]}
        scale={[1, 1, 4.42]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.014' }}
      >
        <mesh
          name="Cube280"
          castShadow
          receiveShadow
          geometry={nodes.Cube280.geometry}
          material={materials['Mud.043']}
        />
        <mesh
          name="Cube280_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube280_1.geometry}
          material={materials['DarkWood.068']}
        />
      </group>
      <group
        name="tileHigh_graveyard004"
        position={[10.55, -1, -13.78]}
        rotation={[0, -1.57, 0]}
        scale={[2.47, 1, 4.42]}
        userData={{ name: 'tileHigh_graveyard.004' }}
      >
        <mesh
          name="Cube281"
          castShadow
          receiveShadow
          geometry={nodes.Cube281.geometry}
          material={materials['Mud.044']}
        />
        <mesh
          name="Cube281_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube281_1.geometry}
          material={materials['DarkWood.069']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard015"
        position={[-8.67, -1.05, 12.7]}
        scale={[1, 1, 4.42]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.015' }}
      >
        <mesh
          name="Cube282"
          castShadow
          receiveShadow
          geometry={nodes.Cube282.geometry}
          material={materials['Mud.045']}
        />
        <mesh
          name="Cube282_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube282_1.geometry}
          material={materials['DarkWood.070']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard016"
        position={[-15.21, -1, 12.7]}
        rotation={[-Math.PI, 0, 0]}
        scale={[-1, -1, -4.42]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.016' }}
      >
        <mesh
          name="Cube283"
          castShadow
          receiveShadow
          geometry={nodes.Cube283.geometry}
          material={materials['Mud.046']}
        />
        <mesh
          name="Cube283_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube283_1.geometry}
          material={materials['DarkWood.071']}
        />
      </group>
      <group
        name="tileHigh_graveyard005"
        position={[-11.95, -1, 12.76]}
        scale={[2.47, 1, 4.42]}
        userData={{ name: 'tileHigh_graveyard.005' }}
      >
        <mesh
          name="Cube284"
          castShadow
          receiveShadow
          geometry={nodes.Cube284.geometry}
          material={materials['Mud.047']}
        />
        <mesh
          name="Cube284_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube284_1.geometry}
          material={materials['DarkWood.072']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard017"
        position={[4, -1, -19.4]}
        rotation={[0, 0, -Math.PI]}
        scale={[-1, -1, -7.28]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.017' }}
      >
        <mesh
          name="Cube285"
          castShadow
          receiveShadow
          geometry={nodes.Cube285.geometry}
          material={materials['Mud.048']}
        />
        <mesh
          name="Cube285_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube285_1.geometry}
          material={materials['DarkWood.073']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard018"
        position={[-2.53, -1.05, -19.4]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[1, 1, 7.28]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.018' }}
      >
        <mesh
          name="Cube286"
          castShadow
          receiveShadow
          geometry={nodes.Cube286.geometry}
          material={materials['Mud.049']}
        />
        <mesh
          name="Cube286_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube286_1.geometry}
          material={materials['DarkWood.074']}
        />
      </group>
      <group
        name="tileHigh_graveyard006"
        position={[0.75, -1, -19.5]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[2.47, 1, 7.28]}
        userData={{ name: 'tileHigh_graveyard.006' }}
      >
        <mesh
          name="Cube287"
          castShadow
          receiveShadow
          geometry={nodes.Cube287.geometry}
          material={materials['Mud.050']}
        />
        <mesh
          name="Cube287_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube287_1.geometry}
          material={materials['DarkWood.075']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard019"
        position={[9.98, -1.05, 15.71]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[1, 1, 7.28]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.019' }}
      >
        <mesh
          name="Cube288"
          castShadow
          receiveShadow
          geometry={nodes.Cube288.geometry}
          material={materials['Mud.051']}
        />
        <mesh
          name="Cube288_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube288_1.geometry}
          material={materials['DarkWood.076']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard020"
        position={[16.52, -1, 15.71]}
        rotation={[0, 0, -Math.PI]}
        scale={[-1, -1, -7.28]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.020' }}
      >
        <mesh
          name="Cube289"
          castShadow
          receiveShadow
          geometry={nodes.Cube289.geometry}
          material={materials['Mud.052']}
        />
        <mesh
          name="Cube289_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube289_1.geometry}
          material={materials['DarkWood.077']}
        />
      </group>
      <group
        name="tileHigh_graveyard007"
        position={[13.26, -1, 15.61]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[2.47, 1, 7.28]}
        userData={{ name: 'tileHigh_graveyard.007' }}
      >
        <mesh
          name="Cube290"
          castShadow
          receiveShadow
          geometry={nodes.Cube290.geometry}
          material={materials['Mud.053']}
        />
        <mesh
          name="Cube290_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube290_1.geometry}
          material={materials['DarkWood.078']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard021"
        position={[-0.15, -1, 13.52]}
        rotation={[-Math.PI, 1.57, 0]}
        scale={[-1, -1, -4.42]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.021' }}
      >
        <mesh
          name="Cube291"
          castShadow
          receiveShadow
          geometry={nodes.Cube291.geometry}
          material={materials['Mud.054']}
        />
        <mesh
          name="Cube291_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube291_1.geometry}
          material={materials['DarkWood.079']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard022"
        position={[-0.15, -1.05, 20.06]}
        rotation={[0, -1.57, 0]}
        scale={[1, 1, 4.42]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.022' }}
      >
        <mesh
          name="Cube292"
          castShadow
          receiveShadow
          geometry={nodes.Cube292.geometry}
          material={materials['Mud.055']}
        />
        <mesh
          name="Cube292_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube292_1.geometry}
          material={materials['DarkWood.080']}
        />
      </group>
      <group
        name="tileHigh_graveyard008"
        position={[-0.21, -1, 16.78]}
        rotation={[0, -1.57, 0]}
        scale={[2.47, 1, 4.42]}
        userData={{ name: 'tileHigh_graveyard.008' }}
      >
        <mesh
          name="Cube293"
          castShadow
          receiveShadow
          geometry={nodes.Cube293.geometry}
          material={materials['Mud.056']}
        />
        <mesh
          name="Cube293_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube293_1.geometry}
          material={materials['DarkWood.081']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard023"
        position={[-9.78, -1, -17.04]}
        rotation={[-Math.PI, 1.57, 0]}
        scale={[-1, -1, -4.42]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.023' }}
      >
        <mesh
          name="Cube294"
          castShadow
          receiveShadow
          geometry={nodes.Cube294.geometry}
          material={materials['Mud.057']}
        />
        <mesh
          name="Cube294_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube294_1.geometry}
          material={materials['DarkWood.082']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard024"
        position={[-9.78, -1.05, -10.5]}
        rotation={[0, -1.57, 0]}
        scale={[1, 1, 4.42]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.024' }}
      >
        <mesh
          name="Cube295"
          castShadow
          receiveShadow
          geometry={nodes.Cube295.geometry}
          material={materials['Mud.058']}
        />
        <mesh
          name="Cube295_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube295_1.geometry}
          material={materials['DarkWood.083']}
        />
      </group>
      <group
        name="tileHigh_graveyard009"
        position={[-9.84, -1, -13.78]}
        rotation={[0, -1.57, 0]}
        scale={[2.47, 1, 4.42]}
        userData={{ name: 'tileHigh_graveyard.009' }}
      >
        <mesh
          name="Cube296"
          castShadow
          receiveShadow
          geometry={nodes.Cube296.geometry}
          material={materials['Mud.059']}
        />
        <mesh
          name="Cube296_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube296_1.geometry}
          material={materials['DarkWood.084']}
        />
      </group>
      <mesh
        name="treeB_graveyard003"
        castShadow
        receiveShadow
        geometry={nodes.treeB_graveyard003.geometry}
        material={materials['DarkWood.085']}
        position={[6.1, 0, 11.83]}
        rotation={[0, 1.04, 0]}
        userData={{ name: 'treeB_graveyard.003' }}
      />
      <mesh
        name="treeA_graveyard003"
        castShadow
        receiveShadow
        geometry={nodes.treeA_graveyard003.geometry}
        material={materials['DarkWood.086']}
        position={[5.52, 0, 12.82]}
        rotation={[0, 1.04, 0]}
        userData={{ name: 'treeA_graveyard.003' }}
      />
      <mesh
        name="treeD_graveyard003"
        castShadow
        receiveShadow
        geometry={nodes.treeD_graveyard003.geometry}
        material={materials['DarkWood.087']}
        position={[6.41, 0, 14.5]}
        rotation={[Math.PI, -1.4, Math.PI]}
        userData={{ name: 'treeD_graveyard.003' }}
      />
      <mesh
        name="treeC_graveyard003"
        castShadow
        receiveShadow
        geometry={nodes.treeC_graveyard003.geometry}
        material={materials['DarkWood.088']}
        position={[6.15, 0, 15.99]}
        rotation={[Math.PI, -1.4, Math.PI]}
        userData={{ name: 'treeC_graveyard.003' }}
      />
      <mesh
        name="treeD_graveyard004"
        castShadow
        receiveShadow
        geometry={nodes.treeD_graveyard004.geometry}
        material={materials['DarkWood.089']}
        position={[12.53, 0, 3.68]}
        rotation={[Math.PI, -1.4, Math.PI]}
        userData={{ name: 'treeD_graveyard.004' }}
      />
      <mesh
        name="treeC_graveyard004"
        castShadow
        receiveShadow
        geometry={nodes.treeC_graveyard004.geometry}
        material={materials['DarkWood.090']}
        position={[13.8, 0, 5.56]}
        rotation={[Math.PI, -1.4, Math.PI]}
        userData={{ name: 'treeC_graveyard.004' }}
      />
      <mesh
        name="treeB_graveyard004"
        castShadow
        receiveShadow
        geometry={nodes.treeB_graveyard004.geometry}
        material={materials['DarkWood.091']}
        position={[12.23, 0, 1.85]}
        rotation={[0, 1.04, 0]}
        userData={{ name: 'treeB_graveyard.004' }}
      />
      <mesh
        name="treeA_graveyard004"
        castShadow
        receiveShadow
        geometry={nodes.treeA_graveyard004.geometry}
        material={materials['DarkWood.092']}
        position={[11.64, 0, 4.99]}
        rotation={[0, 1.04, 0]}
        userData={{ name: 'treeA_graveyard.004' }}
      />
      <group
        name="tileLow_graveyard015"
        position={[-14.92, -1, -0.74]}
        scale={[3.29, 1, 7.32]}
        userData={{ name: 'tileLow_graveyard.015' }}
      >
        <mesh
          name="Cube297"
          castShadow
          receiveShadow
          geometry={nodes.Cube297.geometry}
          material={materials['Mud.060']}
        />
        <mesh
          name="Cube297_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube297_1.geometry}
          material={materials['DarkWood.093']}
        />
      </group>
      <group
        name="tileLow_graveyard016"
        position={[14.13, -1, -0.74]}
        scale={[3.29, 1, 7.32]}
        userData={{ name: 'tileLow_graveyard.016' }}
      >
        <mesh
          name="Cube298"
          castShadow
          receiveShadow
          geometry={nodes.Cube298.geometry}
          material={materials['Mud.061']}
        />
        <mesh
          name="Cube298_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube298_1.geometry}
          material={materials['DarkWood.094']}
        />
      </group>
      <group name="pumpkinSmall001" position={[2.24, 0.19, -8.09]} userData={{ name: 'pumpkinSmall.001' }}>
        <mesh
          name="Sphere004"
          castShadow
          receiveShadow
          geometry={nodes.Sphere004.geometry}
          material={materials['Orange.014']}
        />
        <mesh
          name="Sphere004_1"
          castShadow
          receiveShadow
          geometry={nodes.Sphere004_1.geometry}
          material={materials['GreenDark.002']}
        />
      </group>
      <group name="pumpkinLarge001" position={[2.93, 0.34, -8.16]} userData={{ name: 'pumpkinLarge.001' }}>
        <mesh
          name="Sphere005"
          castShadow
          receiveShadow
          geometry={nodes.Sphere005.geometry}
          material={materials['Orange.015']}
        />
        <mesh
          name="Sphere005_1"
          castShadow
          receiveShadow
          geometry={nodes.Sphere005_1.geometry}
          material={materials['GreenDark.003']}
        />
      </group>
      <mesh
        name="treeD_graveyard005"
        castShadow
        receiveShadow
        geometry={nodes.treeD_graveyard005.geometry}
        material={materials['DarkWood.095']}
        position={[-14.82, 0, 3.08]}
        rotation={[0, 0.72, 0]}
        userData={{ name: 'treeD_graveyard.005' }}
      />
      <mesh
        name="treeC_graveyard005"
        castShadow
        receiveShadow
        geometry={nodes.treeC_graveyard005.geometry}
        material={materials['DarkWood.096']}
        position={[-13.68, 0, 2.08]}
        rotation={[0, 0.72, 0]}
        userData={{ name: 'treeC_graveyard.005' }}
      />
      <mesh
        name="treeB_graveyard005"
        castShadow
        receiveShadow
        geometry={nodes.treeB_graveyard005.geometry}
        material={materials['DarkWood.097']}
        position={[-16.27, 0, 5.34]}
        rotation={[Math.PI, -0.36, Math.PI]}
        userData={{ name: 'treeB_graveyard.005' }}
      />
      <mesh
        name="treeA_graveyard005"
        castShadow
        receiveShadow
        geometry={nodes.treeA_graveyard005.geometry}
        material={materials['DarkWood.098']}
        position={[-15.19, 0, 4.94]}
        rotation={[Math.PI, -0.36, Math.PI]}
        userData={{ name: 'treeA_graveyard.005' }}
      />
      <group name="pumpkinLarge002" position={[15.33, 0.34, -6.69]} userData={{ name: 'pumpkinLarge.002' }}>
        <mesh
          name="Sphere006"
          castShadow
          receiveShadow
          geometry={nodes.Sphere006.geometry}
          material={materials['Orange.016']}
        />
        <mesh
          name="Sphere006_1"
          castShadow
          receiveShadow
          geometry={nodes.Sphere006_1.geometry}
          material={materials['GreenDark.004']}
        />
      </group>
      <group name="pumpkinSmall002" position={[-14.24, 0.19, 5.22]} userData={{ name: 'pumpkinSmall.002' }}>
        <mesh
          name="Sphere007"
          castShadow
          receiveShadow
          geometry={nodes.Sphere007.geometry}
          material={materials['Orange.017']}
        />
        <mesh
          name="Sphere007_1"
          castShadow
          receiveShadow
          geometry={nodes.Sphere007_1.geometry}
          material={materials['GreenDark.005']}
        />
      </group>
      <group
        name="coffinB_top001"
        position={[0.22, 0.78, -10.07]}
        rotation={[0, -1.57, 0]}
        userData={{ name: 'coffinB_top.001' }}
      >
        <mesh
          name="Cube300"
          castShadow
          receiveShadow
          geometry={nodes.Cube300.geometry}
          material={materials['Black.053']}
        />
        <mesh
          name="Cube300_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube300_1.geometry}
          material={materials['Metal.004']}
        />
        <mesh
          name="Cube300_2"
          castShadow
          receiveShadow
          geometry={nodes.Cube300_2.geometry}
          material={materials['Red.002']}
        />
      </group>
      <mesh
        name="gravestone001"
        castShadow
        receiveShadow
        geometry={nodes.gravestone001.geometry}
        material={materials['Stone.069']}
        position={[-14.06, -0.38, -3.45]}
        rotation={[-0.26, -0.59, 0]}
        userData={{ name: 'gravestone.001' }}
      />
      <mesh
        name="gravestone002"
        castShadow
        receiveShadow
        geometry={nodes.gravestone002.geometry}
        material={materials['Stone.070']}
        position={[-16.38, -0.31, -5.52]}
        rotation={[0.13, -0.59, 0]}
        userData={{ name: 'gravestone.002' }}
      />
      <mesh
        name="gravestone003"
        castShadow
        receiveShadow
        geometry={nodes.gravestone003.geometry}
        material={materials['Stone.071']}
        position={[-14.06, -0.27, -5.52]}
        rotation={[0, -0.59, 0]}
        userData={{ name: 'gravestone.003' }}
      />
      <mesh
        name="gravestone004"
        castShadow
        receiveShadow
        geometry={nodes.gravestone004.geometry}
        material={materials['Stone.072']}
        position={[15.55, -0.27, -4.89]}
        rotation={[0, -1.26, 0]}
        userData={{ name: 'gravestone.004' }}
      />
      <mesh
        name="gravestone005"
        castShadow
        receiveShadow
        geometry={nodes.gravestone005.geometry}
        material={materials['Stone.073']}
        position={[13.72, -0.31, -6.33]}
        rotation={[0.34, -1.25, 0.25]}
        userData={{ name: 'gravestone.005' }}
      />
      <mesh
        name="gravestone006"
        castShadow
        receiveShadow
        geometry={nodes.gravestone006.geometry}
        material={materials['Stone.074']}
        position={[14.26, -0.38, -3.27]}
        rotation={[-0.65, -1.21, -0.47]}
        userData={{ name: 'gravestone.006' }}
      />
      <mesh
        name="shrine001"
        castShadow
        receiveShadow
        geometry={nodes.shrine001.geometry}
        material={materials['Stone.065']}
        position={[-9.28, 0, -8.08]}
        userData={{ name: 'shrine.001' }}
      />
      <mesh
        name="shrine002"
        castShadow
        receiveShadow
        geometry={nodes.shrine002.geometry}
        material={materials['Stone.066']}
        position={[8.87, 0, 5.99]}
        userData={{ name: 'shrine.002' }}
      />
      <group
        name="tileLow_graveyard013"
        position={[-9.11, -1, -8.07]}
        rotation={[0, 1.57, 0]}
        scale={[1, 1, 1.18]}
        userData={{ name: 'tileLow_graveyard.013' }}
      >
        <mesh
          name="Cube272"
          castShadow
          receiveShadow
          geometry={nodes.Cube272.geometry}
          material={materials['Mud.038']}
        />
        <mesh
          name="Cube272_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube272_1.geometry}
          material={materials['DarkWood.059']}
        />
      </group>
      <group
        name="tileLow_graveyard014"
        position={[9.04, -1, 6]}
        rotation={[0, 1.57, 0]}
        scale={[1, 1, 1.18]}
        userData={{ name: 'tileLow_graveyard.014' }}
      >
        <mesh
          name="Cube273"
          castShadow
          receiveShadow
          geometry={nodes.Cube273.geometry}
          material={materials['Mud.039']}
        />
        <mesh
          name="Cube273_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube273_1.geometry}
          material={materials['DarkWood.060']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard011"
        position={[2.53, 0.82, 9.27]}
        rotation={[-Math.PI, 0, 0]}
        scale={[-0.83, -1, -1]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.011' }}
      >
        <mesh
          name="Cube275"
          castShadow
          receiveShadow
          geometry={nodes.Cube275.geometry}
          material={materials['Mud.040']}
        />
        <mesh
          name="Cube275_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube275_1.geometry}
          material={materials['DarkWood.061']}
        />
      </group>
      <group
        name="tileSlopeLowHigh_graveyard012"
        position={[4.12, 0.82, 9.27]}
        scale={[0.83, 1, 1]}
        userData={{ name: 'tileSlopeLowHigh_graveyard.012' }}
      >
        <mesh
          name="Cube276"
          castShadow
          receiveShadow
          geometry={nodes.Cube276.geometry}
          material={materials['Mud.041']}
        />
        <mesh
          name="Cube276_1"
          castShadow
          receiveShadow
          geometry={nodes.Cube276_1.geometry}
          material={materials['DarkWood.062']}
        />
      </group>
      <mesh
        name="treeA_graveyard002"
        castShadow
        receiveShadow
        geometry={nodes.treeA_graveyard002.geometry}
        material={materials['DarkWood.064']}
        position={[-6.32, 0, 7.5]}
        rotation={[0, 0.09, 0]}
        userData={{ name: 'treeA_graveyard.002' }}
      />
      <mesh
        name="treeB_graveyard002"
        castShadow
        receiveShadow
        geometry={nodes.treeB_graveyard002.geometry}
        material={materials['DarkWood.063']}
        position={[-5.17, 0, 7.4]}
        rotation={[0, 0.09, 0]}
        userData={{ name: 'treeB_graveyard.002' }}
      />
      <mesh
        name="treeC_graveyard002"
        castShadow
        receiveShadow
        geometry={nodes.treeC_graveyard002.geometry}
        material={materials['DarkWood.066']}
        position={[6.22, 0, -8.45]}
        userData={{ name: 'treeC_graveyard.002' }}
      />
      <mesh
        name="treeD_graveyard002"
        castShadow
        receiveShadow
        geometry={nodes.treeD_graveyard002.geometry}
        material={materials['DarkWood.065']}
        position={[4.7, 0, -8.45]}
        userData={{ name: 'treeD_graveyard.002' }}
      />
      <mesh
        name="fence003"
        castShadow
        receiveShadow
        geometry={nodes.fence003.geometry}
        material={materials['Black.055']}
        position={[-13.1, 0, -6.58]}
        rotation={[-0.56, -1.02, -0.41]}
        userData={{ name: 'fence.003' }}
      />
      <mesh
        name="fence004"
        castShadow
        receiveShadow
        geometry={nodes.fence004.geometry}
        material={materials['Black.056']}
        position={[15.45, 0, -0.53]}
        rotation={[-2.44, -1.12, -2.41]}
        userData={{ name: 'fence.004' }}
      />
      <group name="candleBundle001" position={[-9.77, 0, -7.44]} userData={{ name: 'candleBundle.001' }}>
        <mesh
          name="Cylinder106"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder106.geometry}
          material={materials['White.008']}
        />
        <mesh
          name="Cylinder106_1"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder106_1.geometry}
          material={materials['Black.065']}
        />
        <mesh
          name="Cylinder106_2"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder106_2.geometry}
          material={materials['Yellow.013']}
        />
      </group>
    </group>
  )
}

useGLTF.preload(URL)
